export function formatPrice(currency, amount) {
  return amount != null ? `${currency} ${amount.toFixed(2)}` : '';
}
